import React from 'react';
import { Box, Button, Layer } from 'grommet';
import './ResolveRestrictModal.css';
import { useStore } from '../../../../../../../Hooks/useStore';

const ResolvedRestrictModal = () => {
    const { rootStore } = useStore();
    return (
        <Layer
            position="center"
            onClickOutside={() => rootStore.emsStore.handleResolvedPopUp(false)}
            onEsc={() =>rootStore.emsStore.handleResolvedPopUp(false)}
            style={{borderRadius: "12px" }}
            className="mark-resolved-modal"
        >
            <Box className='container'>
                <h2 className='heading'>Mark Resolved</h2>
                <p className='dialog-title mt10'>Only assigned EMS can mark the emergency as resolved.</p>
                <Button className="close-btn mt20" label="Close" onClick={() => rootStore.emsStore.handleResolvedPopUp(false)} />
            </Box>
        </Layer>
    );
}

export default ResolvedRestrictModal;
